import { getAccountPropertiesAsync } from './getAccountPropertiesAsync'

export const MEMBERSHIP_STATES = {
  ACTIVE: 'active',
  ACTIVE_TRIAL: 'trialing',
  LAPSED: 'lapsed',
  SINGLE_CLASS: 'SINGLE_CLASS',
  INACTIVE: 'inactive',
  REFUNDED: 'refunded',
  NEVER_ENROLLED: 'NEVER_ENROLLED',
}

export const getMembershipStateAsync = async (refresh = false) => {
  const { userState } = await getAccountPropertiesAsync(refresh)

  return userState
}
